module.exports = __webpack_public_path__ + "static/media/sell_help_4.f55a69be.jpg";